export const translations = {
  id: {
    nav: {
      features: "Fitur",
      exchanges: "Exchange",
      pricing: "Paket",
      testimonials: "Testimoni",
      tutorial: "Tutorial",
      faq: "FAQ",
      blog: "Artikel",
      register: "Registrasi",
      whatsapp: "Chat WhatsApp",
    },
    hero: {
      badge: "TERDAFTAR BAPPEBTI · 03/BAPPEBTI/SI-PNB/07/2025",
      title_1: "Bot Trading",
      title_2: "Otomatis 24/7",
      title_3: "berbasis AI",
      subtitle:
        "All-in-One Automated Trading Tools. Profit konsisten dari kripto tanpa leverage, tanpa likuidasi, modal tetap aman di akun exchanger Anda sendiri.",
      cta_primary: "Mulai Registrasi",
      cta_secondary: "Chat Admin WhatsApp",
      stats_users: "Pengguna Aktif",
      stats_success: "Tingkat Sukses",
      stats_uptime: "Trading Otomatis",
    },
    ticker: {
      title: "Harga Live",
      subtitle: "Real-time dari CoinMarketCap",
      change_24h: "24j",
      loading: "Memuat harga...",
    },
    features: {
      kicker: "FITUR UNGGULAN",
      title: "Semua yang Anda butuhkan untuk trading dengan tenang",
      items: [
        {
          title: "Custom Bot Fully Configurable",
          desc: "Pilihan mode Grid, Average, atau kombinasi Grid+Average. Ubah jarak antar layer kapan saja tanpa stop bot (maks 100 layer).",
        },
        {
          title: "Keamanan Sistem H2H",
          desc: "Terhubung ke exchanger via API Host-to-Host yang dibatasi ke IP server AIOTrade. Hanya bisa BUY/SELL — tidak bisa Withdraw.",
        },
        {
          title: "Manajemen Risiko Spot",
          desc: "Hanya berjalan di Spot Trading. Tanpa leverage, tanpa likuidasi, tanpa kehilangan aset.",
        },
        {
          title: "Sistem Afiliasi Terbesar",
          desc: "Direct Reward mulai 27%, Team, Peer, Withdraw & Global Reward bulanan. Akun berlaku selamanya.",
        },
        {
          title: "Jaminan Keamanan Modal",
          desc: "Modal & profit tersimpan di Binance / Bitget / Tokocrypto — bukan di AIOTrade. Withdraw kapan pun.",
        },
        {
          title: "Multi Exchange Sekaligus",
          desc: "Terhubung dengan Binance, Bitget, dan Tokocrypto secara bersamaan dalam satu dashboard.",
        },
      ],
    },
    exchanges: {
      kicker: "PARTNER EXCHANGE",
      title: "Terhubung dengan Top Global Exchange",
      desc: "Modal Anda 100% berada di exchanger kelas dunia, bukan di AIOTrade. API Host-to-Host hanya membaca dan eksekusi order — tanpa akses withdraw.",
      legal: "Terdaftar di BAPPEBTI · PT Ruang Investasi Indonesia",
    },
    pricing: {
      kicker: "PAKET HARGA",
      title: "Pilih Paket Anda",
      subtitle: "Bayar sekali. Bot bekerja selamanya. Tidak ada langganan tersembunyi.",
      one_time: "Sekali bayar",
      cta: "Pilih Paket",
      packages: [
        {
          name: "Trading Kripto",
          price: "130",
          note: "termasuk Trading Fee 30 USDT",
          features: [
            "5 bot Kripto aktif bersamaan",
            "3 Mode bot: Grid, Average, Grid+Average",
            "3 API exchanger (Binance, Bitget, Tokocrypto)",
            "100 layer (fully customize down price)",
            "Trailing stop Buy / Sell",
            "Jurnal trading sistematis",
            "Support handal via Meet, WhatsApp, Telegram",
            "Reward afiliasi mulai dari 27%",
          ],
          popular: true,
          badge: "Paling Populer",
          accent: "brand",
        },
        {
          name: "Trading Saham",
          price: "130",
          note: "termasuk Trading Fee 60 USDT",
          features: [
            "5 bot saham",
            "3 Mode bot: Grid, Average, Grid+Average",
            "1 API Bursa Saham (NYSE / NASDAQ)",
            "100 layer (fully customize)",
            "Trailing stop Buy / Sell",
            "Jurnal trading sistematis",
            "Support handal premium",
            "Reward afiliasi mulai dari 27%",
          ],
          badge: "Paling Ditunggu",
          accent: "teal",
        },
        {
          name: "Kripto + Saham",
          price: "190",
          note: "termasuk Trading Fee 90 USDT",
          features: [
            "Semua fitur Kripto + Saham",
            "Harga Diskon kombo",
            "5 bot Kripto + 5 bot Saham",
            "Prioritas support",
          ],
          badge: "Paling Hemat",
          accent: "yellow",
        },
      ],
    },
    testimonials: {
      kicker: "TESTIMONI",
      title: "Apa kata pengguna AIOTrade",
      items: [
        {
          name: "Andika P.",
          role: "Trader Kripto · Jakarta",
          quote:
            "Sudah 8 bulan pakai AIOTrade. Bot Grid+Average bikin saya tidur nyenyak. Modal di Binance, profit konsisten masuk tiap minggu.",
        },
        {
          name: "Siti R.",
          role: "Pengusaha · Bandung",
          quote:
            "Awalnya skeptis karena banyak penipuan. Tapi karena modal tetap di Binance dan AIOTrade terdaftar BAPPEBTI, akhirnya saya coba — sekarang sudah ROI.",
        },
        {
          name: "Bayu W.",
          role: "Software Engineer · Surabaya",
          quote:
            "Suka sekali H2H API-nya. Saya cek manual, server AIOTrade benar-benar tidak bisa withdraw. Setup 10 menit, langsung jalan.",
        },
        {
          name: "Dewi L.",
          role: "Ibu Rumah Tangga · Bali",
          quote:
            "Saya bukan trader. Saya pakai Follow Master mode. Tinggal duduk manis, profit jalan otomatis. Admin WhatsApp juga sangat helpful.",
        },
      ],
    },
    tutorial: {
      kicker: "TUTORIAL",
      title: "Mulai trading dalam 6 langkah",
      desc: "Tonton video tutorial atau download panduan PDF lengkap untuk setup AIOTrade dari nol sampai bot pertama berjalan.",
      watch_video: "Tonton Tutorial YouTube",
      download_pdf: "Download User Guide PDF",
      marketing_plan: "Marketing Plan PDF",
      steps: [
        "Registrasi akun di AIOTrade.",
        "Buat akun di Binance / Bitget / Tokocrypto (jika belum).",
        "Top-up 130 atau 190 USDT, lalu aktivasi akun.",
        "Konfigurasi API Host-to-Host ke exchanger.",
        "Pilih jenis bot (USDT / XAUT / Stock) & strategi.",
        "Bot mulai trading otomatis 24 jam.",
      ],
    },
    faq: {
      kicker: "PERTANYAAN UMUM",
      title: "FAQ — Semua yang ingin Anda tahu",
      items: [
        {
          q: "Apakah AIOTrade itu?",
          a: "AIOTrade adalah alat bantu trading kripto dan saham yang terintegrasi ke exchanger via API (Application Programming Interface) dan bekerja secara kontinu 24 jam.",
        },
        {
          q: "Bagaimana cara kerja AIOTrade?",
          a: "AIOTrade mengirim perintah BUY atau SELL ke exchanger melalui jalur API sesuai konfigurasi Anda. Tanpa kemampuan Withdraw, sehingga dana Anda sangat aman di exchanger.",
        },
        {
          q: "Apa yang dihasilkan AIOTrade?",
          a: "Profit dari selisih buy & sell sesuai Target Profit (TP) yang Anda atur — berjalan otomatis 24 jam, bahkan saat Anda tidur.",
        },
        {
          q: "Berapa profit per bulan?",
          a: "Tidak dapat dipastikan — tergantung modal, pemilihan koin, timing entry, persentase layer, dan kondisi market (bullish, bearish, atau sideways).",
        },
        {
          q: "Apakah saya perlu pengalaman trading?",
          a: "Tidak. AIOTrade dirancang untuk semua level. Tersedia mode Follow Master dengan strategi pre-configured untuk pemula, dan custom setting untuk advanced user.",
        },
        {
          q: "Apakah AIOTrade aman?",
          a: "Ya. (a) Modal Anda berada di exchanger top dunia (Binance, Bitget, Tokocrypto), bukan di AIOTrade. (b) Mode SPOT, tanpa leverage, tanpa Margin Call. (c) Terdaftar resmi di BAPPEBTI di bawah PT Ruang Investasi Indonesia (No. 03/BAPPEBTI/SI-PNB/07/2025).",
        },
        {
          q: "Fitur utama AIOTrade?",
          a: "Mode bot Custom (Grid, Average, Grid+Average) & Follow Master, perdagangan Crypto / XAUT / Saham Amerika, 5 bot bersamaan, sistem afiliasi multi-reward (Direct, Team, Peer, Withdraw, Global) mulai dari 27%.",
        },
        {
          q: "Berapa modal trading yang dibutuhkan?",
          a: "Selain biaya registrasi AIOTrade, modal trading ditaruh di exchanger. Rekomendasi minimal 10 layer × 15 USDT = 150 USDT. Semakin besar modal, semakin besar potensi profit.",
        },
        {
          q: "Bagaimana cara mulai?",
          a: "1) Klik Registrasi. 2) Buat akun di Binance / Bitget / Tokocrypto. 3) Deposit 130 atau 190 USDT lalu aktivasi. 4) Konfigurasi API. 5) Pilih jenis bot. 6) Hubungi Admin WhatsApp jika butuh bantuan.",
        },
        {
          q: "Apakah ada Tutorial & Marketing Plan?",
          a: "Ya — tersedia User Guide PDF, video YouTube, Marketing Plan PDF, serta komunitas aktif di Facebook, Telegram, dan WhatsApp Group.",
        },
      ],
    },
    cta: {
      kicker: "MULAI HARI INI",
      title: "Trading lebih tenang dengan AIOTrade",
      subtitle:
        "Bergabung dengan ribuan trader yang sudah mempercayakan eksekusi otomatis pada AIOTrade. Modal tetap milik Anda, di exchanger Anda.",
      wa: "Chat Admin via WhatsApp",
      tg: "Chat via Telegram",
      register: "Registrasi Sekarang",
    },
    floating: {
      label: "Chat Admin",
    },
    a11y: {
      skip: "Lewati ke konten utama",
      main_nav: "Navigasi utama",
      mobile_nav: "Navigasi menu mobile",
      footer_nav: "Navigasi footer",
      open_menu: "Buka menu navigasi",
      close_menu: "Tutup menu navigasi",
      external: "(buka di tab baru)",
      prices_region: "Harga kripto real-time",
      prices_table: "Daftar harga kripto terkini",
      theme: "Ganti tema warna",
      language: "Ganti bahasa ke",
      close: "Tutup",
    },
    footer: {
      tagline: "All-in-One Automated Trading Tools — Terdaftar BAPPEBTI.",
      community: "Komunitas",
      resources: "Resource",
      contact: "Kontak",
      wa_group: "WhatsApp Group",
      wa_channel: "WhatsApp Channel",
      tg_group: "Telegram Group",
      fb_page: "Facebook Page",
      fb_group: "Facebook Group",
      youtube: "YouTube Tutorial",
      pdf: "User Guide PDF",
      mp: "Marketing Plan",
      wa_admin: "WhatsApp Admin",
      tg_admin: "Telegram Admin",
      rights: "Semua hak dilindungi.",
      legal: "AIOTrade beroperasi di bawah PT Ruang Investasi Indonesia. Trading kripto memiliki risiko. DYOR.",
    },
    blog: {
      kicker: "ARTIKEL & INSIGHT",
      title: "Belajar trading otomatis dari dasar",
      subtitle:
        "Panduan singkat soal strategi bot, manajemen risiko, dan legalitas kripto di Indonesia.",
      read_all: "Lihat semua artikel",
      read_more: "Baca selengkapnya",
      back: "Kembali ke artikel",
      home: "Beranda",
      published: "Dipublikasikan",
      cta_title: "Siap mencoba bot AIOTrade?",
      cta_desc:
        "Tim admin membantu konfigurasi pertama Anda, dari API key sampai parameter bot.",
      cta_btn: "Chat Admin",
      other: "Artikel lainnya",
      share: "Bagikan artikel",
      copy_link: "Salin tautan",
      copied: "Tautan disalin",
      meta_title: "Artikel AIOTrade — Panduan Bot Trading Kripto",
      meta_desc:
        "Panduan praktis seputar bot trading kripto: strategi grid, averaging (DCA), manajemen risiko, dan cara cek legalitas penyedia di Indonesia.",
    },
    sticky: {
      label: "Registrasi Sekarang",
      note: "Bayar sekali · Bot aktif 24/7",
    },
    estimator: {
      title: "Kalkulator Estimasi Hasil",
      subtitle:
        "Atur modal dan target bulanan Anda untuk melihat gambaran pertumbuhan dengan sistem compound.",
      capital: "Modal trading di exchange",
      rate: "Target profit per bulan",
      months: "Lama berjalan",
      month_unit: "bulan",
      result_final: "Perkiraan saldo akhir",
      result_profit: "Perkiraan profit (compound)",
      result_simple: "Tanpa compound (profit ditarik tiap bulan)",
      disclaimer:
        "Angka di atas hanya simulasi matematis dari target yang Anda masukkan, bukan janji atau jaminan hasil. Profit nyata bergantung pada kondisi market, pemilihan pair, dan pengaturan bot. Trading kripto memiliki risiko.",
      compound_link: "Buka kalkulator compound lengkap",
      chart_title: "Pertumbuhan saldo per bulan (USDT)",
      month_label: "Bulan",
      legend_compound: "Dengan compound",
      legend_flat: "Tanpa compound",
    },
  },
  en: {
    nav: {
      features: "Features",
      exchanges: "Exchanges",
      pricing: "Pricing",
      testimonials: "Testimonials",
      tutorial: "Tutorial",
      faq: "FAQ",
      blog: "Articles",
      register: "Register",
      whatsapp: "WhatsApp Chat",
    },
    hero: {
      badge: "REGISTERED AT BAPPEBTI · 03/BAPPEBTI/SI-PNB/07/2025",
      title_1: "Automated",
      title_2: "Trading Bots",
      title_3: "powered by AI",
      subtitle:
        "All-in-One Automated Trading Tools. Consistent crypto profit with zero leverage, zero liquidation — your capital stays safe in your own exchanger account.",
      cta_primary: "Register Now",
      cta_secondary: "Chat WhatsApp Admin",
      stats_users: "Active Users",
      stats_success: "Success Rate",
      stats_uptime: "Auto Trading",
    },
    ticker: {
      title: "Live Prices",
      subtitle: "Real-time from CoinMarketCap",
      change_24h: "24h",
      loading: "Loading prices...",
    },
    features: {
      kicker: "CORE FEATURES",
      title: "Everything you need to trade with peace of mind",
      items: [
        {
          title: "Fully Customizable Bots",
          desc: "Choose Grid, Average, or combined Grid+Average mode. Change layer spacing on the fly without stopping the bot (up to 100 layers).",
        },
        {
          title: "Host-to-Host API Security",
          desc: "Connects to exchangers via H2H API restricted to AIOTrade server IPs. Only BUY / SELL allowed — never Withdraw.",
        },
        {
          title: "Spot-Only Risk Management",
          desc: "Spot trading only. No leverage, no liquidation, no asset loss.",
        },
        {
          title: "Biggest Affiliate System",
          desc: "Direct Reward from 27%, plus Team, Peer, Withdraw & monthly Global Reward. Lifetime accounts.",
        },
        {
          title: "Capital Stays With You",
          desc: "Funds & profits sit in Binance / Bitget / Tokocrypto — not AIOTrade. Withdraw anytime.",
        },
        {
          title: "Multi-Exchange at Once",
          desc: "Connect Binance, Bitget, and Tokocrypto simultaneously from a single dashboard.",
        },
      ],
    },
    exchanges: {
      kicker: "EXCHANGE PARTNERS",
      title: "Plugged into top global exchanges",
      desc: "Your capital lives 100% on world-class exchangers, never on AIOTrade. H2H API is read & execute only — no withdraw permission.",
      legal: "Registered at BAPPEBTI · PT Ruang Investasi Indonesia",
    },
    pricing: {
      kicker: "PRICING",
      title: "Choose your plan",
      subtitle: "One-time payment. Bot runs forever. No hidden subscriptions.",
      one_time: "One-time payment",
      cta: "Get this plan",
      packages: [
        {
          name: "Crypto Trading",
          price: "130",
          note: "incl. 30 USDT Trading Fee",
          features: [
            "5 concurrent crypto bots",
            "3 bot modes: Grid, Average, Grid+Average",
            "3 exchanger APIs (Binance, Bitget, Tokocrypto)",
            "100 layers (fully customizable)",
            "Trailing stop Buy / Sell",
            "Systematic trading journal",
            "Premium support via Meet, WhatsApp, Telegram",
            "Affiliate reward starting at 27%",
          ],
          popular: true,
          badge: "Most Popular",
          accent: "brand",
        },
        {
          name: "Stock Trading",
          price: "130",
          note: "incl. 60 USDT Trading Fee",
          features: [
            "5 stock bots",
            "3 bot modes: Grid, Average, Grid+Average",
            "1 Stock Exchange API (NYSE / NASDAQ)",
            "100 layers (fully customizable)",
            "Trailing stop Buy / Sell",
            "Systematic trading journal",
            "Premium support",
            "Affiliate reward starting at 27%",
          ],
          badge: "Most Anticipated",
          accent: "teal",
        },
        {
          name: "Crypto + Stock",
          price: "190",
          note: "incl. 90 USDT Trading Fee",
          features: [
            "All Crypto + Stock features",
            "Combo discount",
            "5 crypto + 5 stock bots",
            "Priority support",
          ],
          badge: "Best Value",
          accent: "yellow",
        },
      ],
    },
    testimonials: {
      kicker: "TESTIMONIALS",
      title: "What AIOTrade users say",
      items: [
        {
          name: "Andika P.",
          role: "Crypto Trader · Jakarta",
          quote:
            "Been using AIOTrade for 8 months. Grid+Average bot lets me sleep at night — capital sits on Binance, profits land weekly.",
        },
        {
          name: "Siti R.",
          role: "Entrepreneur · Bandung",
          quote:
            "Skeptical at first because of scams. But since funds stay on Binance and AIOTrade is BAPPEBTI-registered, I tried it — already ROI.",
        },
        {
          name: "Bayu W.",
          role: "Software Engineer · Surabaya",
          quote:
            "Love the H2H API — I checked manually, AIOTrade really cannot withdraw. 10-minute setup, then it just runs.",
        },
        {
          name: "Dewi L.",
          role: "Homemaker · Bali",
          quote:
            "I'm not a trader. I use Follow Master mode — sit back, profit runs automatically. Admin on WhatsApp is super helpful.",
        },
      ],
    },
    tutorial: {
      kicker: "TUTORIAL",
      title: "Start trading in 6 steps",
      desc: "Watch the video tutorial or download the full PDF guide to set up AIOTrade from zero to your first running bot.",
      watch_video: "Watch YouTube Tutorial",
      download_pdf: "Download User Guide PDF",
      marketing_plan: "Marketing Plan PDF",
      steps: [
        "Register an account at AIOTrade.",
        "Create an account at Binance / Bitget / Tokocrypto if you don't have one.",
        "Top-up 130 or 190 USDT, then activate your account.",
        "Configure your H2H API to the exchanger.",
        "Pick a bot type (USDT / XAUT / Stock) & strategy.",
        "Your bot starts trading 24/7 automatically.",
      ],
    },
    faq: {
      kicker: "FAQ",
      title: "FAQ — Everything you'd want to know",
      items: [
        {
          q: "What is AIOTrade?",
          a: "AIOTrade is a crypto & stock trading tool integrated with exchangers via API and running continuously 24/7.",
        },
        {
          q: "How does AIOTrade work?",
          a: "AIOTrade sends BUY / SELL orders to your exchanger over an API channel according to your configuration. Withdraw is never permitted, so your funds stay completely safe at the exchanger.",
        },
        {
          q: "What does AIOTrade produce?",
          a: "Profit from the spread between buy & sell based on your Target Profit (TP) — running 24/7 even while you sleep.",
        },
        {
          q: "How much profit per month?",
          a: "Not guaranteed — depends on capital, coin selection, entry timing, layer spacing, and market conditions (bullish, bearish, or sideways).",
        },
        {
          q: "Do I need trading experience?",
          a: "No. AIOTrade fits every level. Use Follow Master with pre-configured strategies for beginners, or fully custom settings for advanced users.",
        },
        {
          q: "Is AIOTrade safe?",
          a: "Yes. (a) Your capital lives on top exchangers (Binance, Bitget, Tokocrypto), not AIOTrade. (b) SPOT mode only — no leverage, no Margin Call. (c) Officially registered at BAPPEBTI under PT Ruang Investasi Indonesia (No. 03/BAPPEBTI/SI-PNB/07/2025).",
        },
        {
          q: "What are AIOTrade's main features?",
          a: "Custom bot modes (Grid, Average, Grid+Average) & Follow Master, trading for Crypto / XAUT / US Stocks, 5 concurrent bots, multi-reward affiliate system (Direct, Team, Peer, Withdraw, Global) starting at 27%.",
        },
        {
          q: "How much trading capital do I need?",
          a: "Apart from AIOTrade registration fee, trading capital is held at the exchanger. Recommended minimum is 10 layers × 15 USDT = 150 USDT. Larger capital, larger potential profit.",
        },
        {
          q: "How do I get started?",
          a: "1) Register here. 2) Open an account on Binance / Bitget / Tokocrypto. 3) Deposit 130 or 190 USDT and activate. 4) Configure your API. 5) Pick a bot type. 6) Reach our WhatsApp Admin anytime for help.",
        },
        {
          q: "Are there tutorials & a Marketing Plan?",
          a: "Yes — a full User Guide PDF, YouTube tutorial, Marketing Plan PDF, and active communities on Facebook, Telegram, and WhatsApp Group.",
        },
      ],
    },
    cta: {
      kicker: "GET STARTED TODAY",
      title: "Trade calmer with AIOTrade",
      subtitle:
        "Join thousands of traders who already trust AIOTrade with automated execution. Your capital stays yours, on your exchanger.",
      wa: "Chat Admin on WhatsApp",
      tg: "Chat on Telegram",
      register: "Register Now",
    },
    floating: {
      label: "Chat Admin",
    },
    a11y: {
      skip: "Skip to main content",
      main_nav: "Main navigation",
      mobile_nav: "Mobile menu navigation",
      footer_nav: "Footer navigation",
      open_menu: "Open navigation menu",
      close_menu: "Close navigation menu",
      external: "(opens in a new tab)",
      prices_region: "Real-time crypto prices",
      prices_table: "Current crypto price list",
      theme: "Switch colour theme",
      language: "Switch language to",
      close: "Close",
    },
    footer: {
      tagline: "All-in-One Automated Trading Tools — BAPPEBTI Registered.",
      community: "Community",
      resources: "Resources",
      contact: "Contact",
      wa_group: "WhatsApp Group",
      wa_channel: "WhatsApp Channel",
      tg_group: "Telegram Group",
      fb_page: "Facebook Page",
      fb_group: "Facebook Group",
      youtube: "YouTube Tutorial",
      pdf: "User Guide PDF",
      mp: "Marketing Plan",
      wa_admin: "WhatsApp Admin",
      tg_admin: "Telegram Admin",
      rights: "All rights reserved.",
      legal: "AIOTrade operates under PT Ruang Investasi Indonesia. Crypto trading involves risk. DYOR.",
    },
    blog: {
      kicker: "ARTICLES & INSIGHTS",
      title: "Learn automated trading from the ground up",
      subtitle:
        "Short guides on bot strategy, risk management and crypto licensing in Indonesia.",
      read_all: "See all articles",
      read_more: "Read more",
      back: "Back to articles",
      home: "Home",
      published: "Published",
      cta_title: "Ready to try the AIOTrade bot?",
      cta_desc:
        "Our admins help with your first setup, from API keys to bot parameters.",
      cta_btn: "Chat Admin",
      other: "More articles",
      share: "Share this article",
      copy_link: "Copy link",
      copied: "Link copied",
      meta_title: "AIOTrade Articles — Crypto Trading Bot Guides",
      meta_desc:
        "Practical guides on crypto trading bots: grid strategy, averaging (DCA), risk management and how to verify provider licensing in Indonesia.",
    },
    sticky: {
      label: "Register Now",
      note: "One-time payment · Bot runs 24/7",
    },
    estimator: {
      title: "Result Estimate Calculator",
      subtitle:
        "Set your capital and monthly target to see how compounding would shape the growth.",
      capital: "Trading capital on the exchange",
      rate: "Monthly profit target",
      months: "Time running",
      month_unit: "months",
      result_final: "Projected ending balance",
      result_profit: "Projected profit (compounded)",
      result_simple: "Without compounding (profit withdrawn monthly)",
      disclaimer:
        "These figures are a mathematical simulation of the target you entered, not a promise or guarantee. Real profit depends on market conditions, pair selection and bot settings. Crypto trading involves risk.",
      compound_link: "Open the full compound calculator",
      chart_title: "Monthly balance growth (USDT)",
      month_label: "Month",
      legend_compound: "With compounding",
      legend_flat: "Without compounding",
    },
  },
};
